// eslint-disable-next-line no-unused-vars
export default function Builder() {
  return {
    build({
      base
    } = {}) {
      return this._getTemplateResult().toString({
        base
      });
    },

    _toPartialString(options) {
      return this._getTemplateResult()._toPartialString(options);
    }

  };
}